"use client";

import type { ReactNode } from "react";
import { openGreipSupportWidget } from "@/lib/greip-chat/open-support-widget";

type ContentCardInteractiveProps = {
  action: "greipChat";
  className: string;
  children: ReactNode;
};

export default function ContentCardInteractive({
  action,
  className,
  children,
}: ContentCardInteractiveProps) {
  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        if (action === "greipChat") {
          openGreipSupportWidget();
        }
      }}
    >
      {children}
    </button>
  );
}
